import React from 'react';
import PedidoForm from '../../pedidoventa/components/PedidoForm';
import { CotizacionVenta, CotizacionVentaDetalle } from '../../../services/cotizacionVentaService';
import { PedidoVenta, PedidoVentaDetalle } from '../../../services/pedidoVentaService';

type CotizacionVentaUI = CotizacionVenta & {
  ordenCompra?: string;
  transporte?: string;
  ubicacion?: string;
  formaDePago?: string;
  nroSuc?: number;
  cuit?: string;
  tipoIVA?: string;
  dni?: string;
  idCompania?: string;
};

const mapDetalleToPedido = (d: CotizacionVentaDetalle): PedidoVentaDetalle => ({
  nroIdformulario: d.nroIdformulario,
  nroItem: d.nroItem,
  codigoArticulo: d.codigoArticulo,
  descripcionArticulo: d.descripcionArticulo,
  cantidad: d.cantidad,
  precioUnitario: d.precioUnitario ?? d.precioLista,
  descuento: d.descuento ?? d.porcDesc,
  porcDesc: d.porcDesc,
  subtotal: d.subtotal,
  notas: d.notas,
  um: d.um,
  codigoMoneda: d.codigoMoneda,
  cotizacion: d.cotizacion,
});

const mapDetalleToCotizacion = (d: PedidoVentaDetalle): CotizacionVentaDetalle => ({
  nroIdformulario: d.nroIdformulario,
  nroItem: d.nroItem,
  codigoArticulo: d.codigoArticulo,
  descripcionArticulo: d.descripcionArticulo,
  cantidad: d.cantidad,
  precioUnitario: d.precioUnitario,
  precioLista: d.precioUnitario,
  descuento: d.descuento,
  porcDesc: d.porcDesc ?? d.descuento,
  subtotal: d.subtotal,
  notas: d.notas,
  um: d.um,
  codigoMoneda: d.codigoMoneda,
  cotizacion: d.cotizacion,
});

const toPedidoVenta = (c: CotizacionVentaUI): PedidoVenta & { ordenCompra?: string; transporte?: string; ubicacion?: string; formaDePago?: string; nroSuc?: number; cuit?: string; tipoIVA?: string; dni?: string; idCompania?: string } => ({
  ...c,
  codigoMoneda: typeof c.codigoMoneda === 'number' ? String(c.codigoMoneda) : (c.codigoMoneda ?? ''),
  nroTipoFormulario: '10',
  detalles: (c.detalles || []).map(mapDetalleToPedido),
});

const toCotizacionVenta = (p: PedidoVenta): CotizacionVenta => ({
  ...p,
  nroTipoFormulario: '10',
  detalles: (p.detalles || []).map(mapDetalleToCotizacion),
});

interface CotizacionFormProps {
  cotizacion: CotizacionVentaUI;
  onCotizacionChange: (cotizacion: CotizacionVenta) => void;
  onClienteSearch: () => void;
  onProductoSearch: () => void;
  onSave: () => void;
  loading: boolean;
  saveButtonText?: string;
  readOnly?: boolean;
}

const CotizacionForm: React.FC<CotizacionFormProps> = ({
  cotizacion,
  onCotizacionChange,
  onClienteSearch,
  onProductoSearch,
  onSave,
  loading,
  saveButtonText = 'Guardar Cotización',
  readOnly = false,
}) => {
  const pedidoVenta = toPedidoVenta(cotizacion);

  const handlePedidoChange = (pedido: PedidoVenta) => {
    onCotizacionChange(toCotizacionVenta(pedido));
  };

  return (
    <PedidoForm
      pedidoVenta={pedidoVenta}
      onPedidoChange={handlePedidoChange}
      onClienteSearch={onClienteSearch}
      onProductoSearch={onProductoSearch}
      onSave={onSave}
      loading={loading}
      saveButtonText={saveButtonText}
      readOnly={readOnly}
    />
  );
};

export default CotizacionForm;
